import { DateTime } from "luxon";

const mixins = {
  methods: {
    imageUrl: (
      imageUrl,
      width,
      height,
      { quality = 50, blur = 0, focus = "center", loseLess = true }
    ) => {
      if (!imageUrl) {
        return "";
      }

      imageUrl += `?tr=${width ? `w-${width},` : ""}${
        height ? `h-${height},` : ""
      }bl-${blur},lo-${loseLess},q-${quality},fo-${focus}`;
      return imageUrl;
    },
    getUpperLetters: text => {
      return text.match(/\b([A-Z])/g).join("");
    },
    formatDateTime: (date, option) => {
      return DateTime.fromSQL(date).toLocaleString(option);
    },
    getRequestProps: ({ onEdit, basePath, modelName, id }) => {
      return {
        url: onEdit ? `${basePath}/${id}` : basePath,
        method: onEdit ? "PUT" : "POST",
        message: onEdit
          ? `mengubah satu ${modelName}`
          : `menambah ${modelName} baru`
      };
    },
    async getFile(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const filename = url.split("/").pop();

      return new File([blob], filename, { type: blob.type });
    },
    dateTimeToTimeStringUtc: dateTime => {
      const timeOffset = dateTime.getTimezoneOffset() / 60;
      dateTime.setHours(dateTime.getHours() + timeOffset);

      let hour = dateTime.getHours().toString();
      hour = hour.length < 2 ? `0${hour}` : hour;
      let minute = dateTime.getMinutes().toString();
      minute = minute.length < 2 ? `0${minute}` : minute;

      return `${hour}:${minute}`;
    },
    timeUtcToDateTimelocal: timeString => {
      const dateTime = new Date();
      const timeOffset = (dateTime.getTimezoneOffset() / 60) * -1;
      const time = timeString.match(/(\d+)(?::(\d\d))?\s*(p?)/);
      dateTime.setHours(parseInt(time[1]) + (time[3] ? 12 : 0) + timeOffset);
      dateTime.setMinutes(parseInt(time[2]) || 0);

      return dateTime;
    },
    dateTimeUtcToTimeStringlocal: dateTimeString => {
      const dateTime = new Date(dateTimeString);
      const timeOffset = (dateTime.getTimezoneOffset() / 60) * -1;
      dateTime.setHours(dateTime.getHours() + timeOffset);

      let hour = dateTime.getHours().toString();
      hour = hour.length < 2 ? `0${hour}` : hour;
      let minute = dateTime.getMinutes().toString();
      minute = minute.length < 2 ? `0${minute}` : minute;

      return `${hour}:${minute}`;
    },
    timeUtcToTimeStringlocal: timeString => {
      const dateTime = new Date();
      const timeOffset = (dateTime.getTimezoneOffset() / 60) * -1;
      const time = timeString.match(/(\d+)(?::(\d\d))?\s*(p?)/);
      dateTime.setHours(parseInt(time[1]) + (time[3] ? 12 : 0) + timeOffset);
      dateTime.setMinutes(parseInt(time[2]) || 0);

      let hour = dateTime.getHours().toString();
      hour = hour.length < 2 ? `0${hour}` : hour;
      let minute = dateTime.getMinutes().toString();
      minute = minute.length < 2 ? `0${minute}` : minute;

      return `${hour}:${minute}`;
    }
  }
};

export default mixins;
